/**
 * Where the eye is when the page is drawn in perspective, shared between the
 * shelf and the book taken off it so the one leaves the other without a jump.
 */

import type { ThemeId } from "../shelf-look";

/** How far the eye stands from the page, in viewport heights. The classic case is drawn nearly flat. */
export const EYE_DISTANCE = 1.9;

/**
 * How far down the viewport the eye rests, as a fraction of its height. The
 * desk is looked down on, as a desk is, so the tops of the piles show.
 */
export const EYE_LEVEL = {
  sunlit: 0.5,
  classic: 0.5,
  gallery: 0.5,
  studio: 0.5,
  modern: 0.5,
  desk: 0.3,
} satisfies Record<ThemeId, number>;

/** How far the eye wanders from its resting point as the pointer moves, as a fraction of the viewport. */
export const EYE_WANDER = { x: 0.07, y: 0.05 };

/**
 * How far the eye has wandered right now, in viewport pixels. The room rig
 * writes it every frame; the inspector reads it when a book is picked up.
 */
export const eyeDrift = { x: 0, y: 0 };

/** The eye's resting point in the viewport, for a room `theme`. */
export function restingEye(theme: ThemeId) {
  return { x: window.innerWidth / 2, y: window.innerHeight * EYE_LEVEL[theme] };
}
